/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Sidan hittades inte",
  "ComingSoon": "Kommer snart",
  "YesanPersonalFinance": "Yesan, Privatekonomi",
  "Yesan": "Yesan",
  "PersonalFinance": "Ekonomi för privatpersoner",
  "YesanDownload": "Yesan Ladda ner",
  "ThisWebsiteUsesCookies": "Vi använder cookies för att samla in och analysera information om vår webbplats prestanda och användning, och för att tillhandahålla funktioner för sociala medier. Genom att fortsätta godkänner du vår",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Bli ekonomiskt fri",
  "inStepsAndActions": "i 8 steg och 3 åtgärder.",
  "TrackPlanAnalyze": "Spåra. Planera. Analysera.",
  "FTrack": "1. Spåra",
  "FPlan": "2. Planera",
  "FAnalyze": "3. Analysera",
  "Features": "Funktioner",
  "FeaturesSubHeading": "För dig som är nybörjare eller redan har koll på din ekonomi är det här appen du behöver för att bli ekonomiskt fri.",
  "ManageAccounts": "Hantera konton",
  "CashLiquidFixedAssetsLiabilities": "Kontanter, likvida medel, fasta tillgångar och skulder.",
  "TrackTransactions": "Spåra transaktioner",
  "IncomesExpensesTransferInvestments": "Inkomster, utgifter, överföringar, investeringar.",
  "ImportExport": "Importera/exportera",
  "YourDataAlwaysAccessible": "Dina data är alltid tillgängliga.",
  "PlanYourFreedom": "Planera din frihet",
  "StepsAwayFromFI": "8 steg bort från ekonomiskt oberoende.",
  "BudgetsAndGoals": "Budgetar och mål",
  "CheckYourProgressAndAchieve": "Kontrollera dina framsteg och uppnå dina finansiella mål.",
  "DashboardAndAnalytics": "Instrumentpanel och analys",
  "ReviewLearnOptimizeWith": "Granska, lär dig och optimera med diagram, insikter och verktyg.",
  "Security": "Säkerhet",
  "MilitaryGradeEncryption": "Kryptering av militär kvalitet, stöd för biometri, data lagras på dina enheter.",
  "OfflineMode": "Offline-läge",
  "YourDataAlwaysAccessibleAndModif": "Dina data är alltid åtkomliga och modifierbara.",
  "Track": "Spåra",
  "Income": "Inkomster",
  "Expense": "Utgifter",
  "Transfer": "Överföring",
  "transactionsAndManageAccounts": "transaktioner och hantera olika konton:",
  "checkings": "Kontroll",
  "savings": "Sparande",
  "realEstate": "Fastigheter",
  "stocks": "Aktiemarknader",
  "bonds": "Obligationer",
  "crypto": "Krypto",
  "notes": "Sedlar, kontanter Plånbok",
  "envelopes": "Kuvert",
  "privateEquity": "Privat kapital",
  "metal": "Metall",
  "retirement": "Pensionering",
  "lifeInsurance": "Livförsäkring",
  "intellectualProperty": "Immateriella tillgångar",
  "otherLiquidAsset": "Övriga likvida tillgångar",
  "otherFixedAsset": "Annan anläggningstillgång",
  "mortgage": "Hypotekslån",
  "loan": "Konsumentlån",
  "creditCard": "Kreditkort",
  "otherLiability": "Övriga skulder",
  "AccountsManagement": "Hantering av konton",
  "MultipleAccountsTypesAndGrouping": "Flera kontotyper och gruppering",
  "LinkAccounts": "Länka konton från dina institutioner (endast tillgängligt i vissa länder)",
  "SmartAccounts": "Smarta konton",
  "AddEditDeleteTransactions": "Lägg till / redigera / ta bort transaktioner",
  "TickVerifiedTransactions": "Markera verifierade transaktioner",
  "CategorizeTransactions": "Kategorisera transaktioner",
  "TagTransactions": "Tagga transaktioner",
  "TrackKakeiboType": "Spåra Kakeibo-typ",
  "TrackInvestments": "Spåra investeringar (endast tillgängligt i vissa länder)",
  "ImportFromCSVFile": "Importera hela eller stegvisa transaktioner från CSV-fil",
  "ExportToCSVFile": "Exportera transaktioner till CSV-fil",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 steg mot ekonomiskt oberoende, detaljerad budgetering, nå dina finansiella mål snabbare.",
  "levelsTowardsFI": "8 steg mot ekonomiskt oberoende",
  "EstablishBudgetsPer": "Upprätta budgetar per",
  "account": "konto",
  "accountType": "typ av konto",
  "KakeiboType": "Typ av Kakeibo",
  "category": "Kategori",
  "tag": "Tagg",
  "label": "Etikett",
  "TrackBudgetsPerFrequency": "Spåra budgetar per frekvens",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Skapa mål för utgifter, balans, kassaflöde, åtgärder",
  "TrackGoalsProgress": "Följ utvecklingen av målen",
  "ReviewLearnOptimizeWithReportsCharts": "Granska, lär dig och optimera med rapporter, diagram, trender, insikter och verktyg.",
  "Dashboard": "Instrumentpanel",
  "FSNetWorth": "Finansiella rapporter: Nettovärde",
  "FSPnL": "Finansiella rapporter: Resultaträkning / vinst och förlust",
  "FSBalanceSheetAssetsLiabilities": "Finansiella rapporter: Balansräkning, tillgångar, skulder",
  "FSCashFlow": "Finansiella rapporter: Kassaflödesanalys, Debet Kredit, Flöden",
  "FSFlows": "Finansiella rapporter: Flöden",
  "FSRatios": "Finansiella rapporter: Kvoter",
  "TrendsMonthEnd": "Trender vid månadens slut: Intäkter & kostnader, kassaflöde",
  "TrendsPerformance": "Trender för resultat: YoY, MoM, WoW",
  "IncomeTrendsPer": "Inkomsttrender per",
  "SpendingTrendsPer": "Utgiftstrender per",
  "RecurringItemsIE": "Återkommande poster: Inkomster & utgifter",
  "DebtProgressTrends": "Trender för skuldsättning",
  "KakeiboMTDReviewTrends": "Kakeibo: MTD-granskning, senaste månaden, trender",
  "FIWCLE": "Ekonomiskt oberoende: Väggdiagram, utgifter per livsenergi",
  "DebtPaydownSnowballAvalanche": "Nedbetalning av skulder: Snöboll, lavin",
  "FullyCustomizableAnalyticsRange": "Helt anpassningsbar analys av tidsintervall",
  "ContactUs": "Kontakta oss",
  "Privacy": "Integritet",
  "Terms": "Villkor",
  "About": "Jag godkänner",
  "IAgreeToThe": "Jag samtycker till",
  "AndThe": "och",
  "PrivacyPolicy": "Integritetspolicy",
  "TermsOfUse": "Villkor för användning",

  "DigitalSoftwareExperienceTagline": "Digital mjukvaruupplevelse för den moderna världen",
  "DigitalExperience": "Digital erfarenhet",
  "SoftwareForTheModernWorld": "Programvara för den moderna världen",
  "MobileApplications": "Mobila applikationer",
  "forConnectedAndOfflineHumans": "för uppkopplade och offline-människor",
  "CloudSaaS": "SaaS i molnet",
  "ResponsiveAndWebServices": "Responsiva tjänster och webbtjänster",
  "PersonalFinanceServices": "Tjänster för privatekonomi",
  "YS_p1": "Yesan är ett dynamiskt mjukvaruföretag som specialiserar sig på utveckling av banbrytande mobilapplikationer skräddarsydda för konsumenter. Med en djup förståelse för de föränderliga behoven och preferenserna hos dagens teknikintresserade användare, är Yesan dedikerade till att skapa intuitiva, engagerande och funktionsrika mobila upplevelser som berikar användarnas liv.",
  "YS_p2": "Kärnan i Yesans uppdrag är ett obevekligt engagemang för innovation och kreativitet, varje produkt är minutiöst utformad för att leverera sömlös funktionalitet och en exceptionell användarupplevelse.",
  "PersonalFinanceApplication": "Applikation för personlig ekonomi",
  "YPF_p1": "Yesan, Personal Finance är en banbrytande mobilapplikation för privatekonomi som är utformad för att ge användarna omfattande verktyg för ekonomisk förvaltning som är lättillgängliga direkt i fingertopparna. Med ett snyggt och intuitivt gränssnitt erbjuder Yesan, Personal Finance ett holistiskt tillvägagångssätt för att hantera ekonomin och tillgodoser användare på alla nivåer av finansiell läskunnighet.",
  "YPF_p2": "Viktiga funktioner inkluderar budgetspårning, kostnadskategorisering och transaktionsövervakning i realtid, så att användarna enkelt kan få insikter om sina utgiftsvanor. Appen erbjuder också anpassningsbara budgetalternativ, så att användarna kan sätta upp finansiella mål och spåra sina framsteg över tiden.",
  "YPF_p3": "Yesan, Personal Finance prioriterar dessutom säkerhet och använder toppmoderna krypteringsprotokoll för att skydda användarnas känsliga finansiella information. Med säkerhetsåtgärder på banknivå kan användarna tryggt länka sina konton och synkronisera transaktioner utan att kompromissa med integriteten.",
  "YPF_p4": "Yesan, Personal Finance går längre än grundläggande budgetering genom att erbjuda insiktsfulla analyser och personliga rekommendationer för att optimera finansiella beslut. Oavsett om det handlar om att identifiera potentiella besparingsmöjligheter, övervaka investeringsportföljer eller hantera strategier för återbetalning av skulder, ger appen skräddarsydda insikter som hjälper användarna att uppnå sina finansiella mål.",
  "Discover": "Upptäck",
  "Firstname": "Förnamn",
  "Lastname": "Efternamn",
  "Company":"Företag",
  "Subject": "Ämne",
  "Email": "E-post",
  "Message": "Meddelande",
  "ThankYouForContactingUs": "Tack för att du kontaktade oss",
  "ValidFirstnameRequired": "Giltigt förnamn krävs.",
  "ValidLastnameRequired": "Giltigt efternamn krävs.",
  "ValidEmailAddressRequired": "Ange en giltig e-postadress.",
  "ValidSubjectRequired": "Vänligen välj ett giltigt ämne.",
  "ValidMessageRequired": "Vänligen ange ett giltigt meddelande.",
  "UnableToSendTheFormPleaseRetryLater": "Det gick inte att skicka formuläret, försök igen senare.",
  "Information": "Information",
  "Sales":"Försäljning",
  "Support": "Stöd",
  "Press": "Tryck",
  "Partnership": "Partnerskap",
  "Other": "Övriga",
  "Blog":"Blogg",

  "Accept":"Acceptera",
  "Decline":"Avslag",

  "WorklogCalendar":"Worklog-kalender för Jira",

  "DirectlyAccessibleInProjectApps":"Direkt åtkomlig i projektappar",
  "VisualizeWhereYouSpentYourTime":"Visualisera var du tillbringade din tid",
  "AllYourWorklogsInACalendar":"Alla dina arbetsloggar i en kalender",
  "MonthSummary":"Månadsöversikt",
  "CheckIfYouForgotToLogTime":"Kontrollera om du har glömt att logga tid.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Direktåtkomst till ärenden och uppdatering av tid",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Klicka på arbetsloggen för att direkt komma åt frågorna och redigera din spårade tid",
  "AlsoAvailableInDarkMode":"Finns även i mörkt läge",
  "DirectlyLogWorkOnTheCalendarVisually":"Logga arbetet visuellt direkt i kalendern",
  "ClickOnTheCalendarToCreateNewWorklog":"Klicka på kalendern för att skapa en ny arbetslogg",

  "AppsForAtlassian":"Appar för Atlassian",
  "YCL_p1":"Visualisera alla dina arbetsloggar i en kalender med vyer för månad, vecka, arbetsvecka och dag.",
  "YCL_p2":"Logga arbete direkt från kalendern genom att visuellt välja tidslucka.",
  "YCL_p3":"Identifiera om du har glömt att spåra tid för dina tidrapporter.",
  "YCL_p4":"Tillgänglig på ditt språk: Engelska (UK), Engelska (US), Kinesiska (förenklad), Kinesiska (traditionell), Danska, Estniska, Finska, Franska, Isländska, Italienska, Japanska, Koreanska, Norska, Polska, Portugisiska (Brasilien), Portugisiska (Portugal), Ryska, Spanska, Svenska, Tjeckiska, Tyska, Ungerska, Turkiska, Nederländska, Tjeckiska, Ungerska.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Financial Portfolio för Jira",
  "BringRealFinancialPortfolio":"Inför verklig finansiell portföljhantering i Jira. Följ upp budgetar, CapEx/OpEx och projektkostnader på ett och samma ställe.",
  "YFPAboutQ":"Hur mycket kostar våra Jira-projekt egentligen?",
  "YFPAbout":"Financial Portfolio för Jira\nEkonomichefer och PMO:er har svårt att svara på en enkel fråga:\nHur mycket kostar våra Jira-projekt oss egentligen?\nJira spårar arbetet.\nEkonomiavdelningen spårar budgetarna.\nDen här appen kopplar äntligen ihop de två.\n\nFinancial Portfolio förvandlar Jira till en smidig PPM- och ekonomisk planeringsplattform – utan att det krävs dyra företagsverktyg.",
  "YFPPorfolioQ":"Portföljbudgetar och spårning",
  "YFPPorfolioP":"Skapa portföljer över flera Jira-projekt och definiera: Budgetbelopp, valuta, datumintervall, inkluderade projekt, team. Spåra faktiska kostnader automatiskt när arbetet utförs i Jira.",
  "YFPPorfolioListQ":"Portföljer",
  "YFPPorfolioListP":"Skapa finansiella portföljer som kombinerar flera Jira-projekt och se omedelbart: Budget jämfört med faktisk kostnad, projektets förbrukningstakt i realtid, uppdelning mellan CapEx och OpEx, kostnad per ärende och projekt, exporterbara finansiella rapporter. Allt drivs direkt av Jiras arbetsloggar.",
  "CostQ":"Automatisk kostnadsberäkning",
  "CostP":"Förvandla tidrapportering till verkliga finansiella data. Appen: Läser Jira-arbetsloggar, tillämpar timpriser, beräknar verkliga projektkostnader dagligen. Inga kalkylblad. Inget manuellt arbete.",
  "RatesQ":"Priser",
  "RatesP":"Ställ in timpris per projekt, team, globalt",
  "ReportQ":"Finansiell rapportering i CSV",
  "ReportP":"Exportera finansiella data för portföljen på några sekunder. Perfekt för: Ekonomiteam, CFO-rapportering, budgetplanering, revisionsstöd",
  "SettingsQ":"CapEx vs OpEx-klassificering",
  "SettingsP":"Stöd för redovisnings- och revisionskrav. Klassificera arbete i: Kapitaliserbar utveckling (CapEx), Operativt arbete (OpEx). Generera exporterbara rapporter som är färdiga för ekonomiteam."
};

export const documents = {
};
